// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6452":"ff9a345f","6850":"f6e64930"}[chunkId] + ".chunk.css";
};